import React, { useContext } from 'react'
import { GeneralContext } from "../context/AppState"
import { window as w } from "browser-monads"
import Carousel from 'react-elastic-carousel'


export default function FavBooks() {
  const { favBooks } = useContext(GeneralContext)

  const properties = {
    // Activate swipe only on mobile browsers 👇
    enableSwipe: w.innerWidth > 800 ? false : true,
    disableArrowsOnEnd: false,
    showArrows: true,
    focusOnSelect: true,
    // Show 1 item on mobile, 3 on tablet and laptop 👇
    itemsToShow: w.innerWidth < 550 ? 1 : 3,
    itemsToScroll: w.innerWidth < 550 ? 1 : 3
  }

  return (
    <section className="favBooks">
      <h2 className="title_deco">Mes livres favoris</h2>
      <Carousel itemsToShow={1} className="bookSlider" {...properties}>
        {
          favBooks.map((book, i) => (
            <a className="sliderItem" href={book.link} target="_blank" key={i}>
              <img src={book.coverImg} className="bookCoverImg" />
              <div className="bookTitle">{book.title}</div>
            </a>
          ))
        }
      </Carousel>
    </section>
  )
}
